export type RegionStaticDataType = {
  countryCode: string;
  regionLinks: { title: string; slug?: string }[];
};
export { default as AERegions } from './AE';
export { default as AURegions } from './AU';
export { default as CARegions } from './CA';
export { default as DERegions } from './DE';
export { default as GlobalRegions } from './GLOBAL';
export { default as IDRegions } from './ID';
export { default as IERegions } from './IE';
export { default as INRegions } from './IN';
export { default as KYRegions } from './KY';
export { default as NZRegions } from './NZ';
export { default as PHRegions } from './PH';
export { default as SGRegions } from './SG';
export { default as UKRegions } from './UK';
export { default as ZARegions } from './ZA';
